function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isFunction } from '@cloud-sn/v-utils';
import Icon from '../icon';
import { buildComponentName } from '../utils';
var regColor = /^(pink|red|yellow|orange|cyan|green|blue|purple|geekblue|magenta|volcano|gold|lime)(-inverse)?$/;
export default {
  name: buildComponentName('Tag'),
  props: {
    prefixCls: {
      type: String,
      default: 'ux-tag'
    },
    color: {
      type: String,
      default: ''
    },
    closable: {
      type: Boolean,
      default: false
    },
    onBeforeClose: {
      type: Function,
      default: null
    },
    theme: {
      type: String,
      default: 'light',
      validator: function validator(val) {
        return ['light'].indexOf(val) > -1;
      }
    }
  },
  data: function data() {
    return {
      closed: false
    };
  },
  computed: {
    isPresetColor: function isPresetColor() {
      var color = this.color;
      return regColor.test(color);
    },
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          color = this.color,
          isPresetColor = this.isPresetColor,
          theme = this.theme;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-").concat(theme), true), _defineProperty(_ref, "".concat(prefixCls, "-").concat(color), isPresetColor), _defineProperty(_ref, "".concat(prefixCls, "-has-color"), !!(color && !isPresetColor)), _ref;
    },
    style: function style() {
      var color = this.color,
          isPresetColor = this.isPresetColor;
      return {
        backgroundColor: color && !isPresetColor ? color : null
      };
    },
    closeIcon: function closeIcon() {
      var h = this.$createElement;
      var closable = this.closable,
          onClose = this.onClose;
      return closable ? h(Icon, {
        "attrs": {
          "type": "close"
        },
        "on": {
          "click": onClose
        }
      }) : null;
    }
  },
  methods: {
    onAfterLeave: function onAfterLeave() {
      this.$emit('after-close');
    },
    onClose: function onClose(e) {
      var _this = this;

      var $refs = this.$refs,
          onBeforeClose = this.onBeforeClose;
      var tagRef = $refs.tagRef;

      if (tagRef) {
        tagRef.style.width = "".concat(tagRef.getBoundingClientRect().width, "px");
      }

      Promise.resolve(isFunction(onBeforeClose) ? onBeforeClose(e) : true).then(function (ret) {
        if (ret === false) {
          return;
        }

        _this.closed = true;

        _this.$emit('close', e);
      });
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        classes = this.classes,
        style = this.style,
        closeIcon = this.closeIcon,
        closed = this.closed,
        onAfterLeave = this.onAfterLeave;
    var element = closed ? null : h("div", {
      "ref": "tagRef",
      "class": classes,
      "style": style
    }, [this.$slots.default, closeIcon]);
    return h("transition", {
      "attrs": {
        "name": "".concat(prefixCls, "-zoom")
      },
      "on": {
        "after-leave": onAfterLeave
      }
    }, [element]);
  }
};